import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import PostByAgg from "../utils/axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [email, setEmail] = useState('');
  const [roleCode, setRoleCode] = useState('');
  const [roleName, setRoleName] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [musicLabelCode, setMusicLabelCode] = useState('');
  const [musicLabelName, setMusicLabelName] = useState('');

  useEffect(() => {
    const storedEmail = Cookies.get("email");
    const storedRole = Cookies.get("roleCode");
    const storedRoleName = Cookies.get("roleName");
    const loggedIn = Cookies.get("isLoggedIn");
    const musicLabelCode = Cookies.get("musicLabelCode");
    const musicLabelName = Cookies.get("musicLabelName");

    console.log("isLoggedIn from cookies:", loggedIn);

    if (loggedIn) {
        setEmail(storedEmail);
        setRoleCode(storedRole);
        setRoleName(storedRoleName)
        setMusicLabelCode(musicLabelCode);
        setMusicLabelName(musicLabelName);
        setIsLoggedIn(true);
      }else{
        setIsLoggedIn(false)
      }

    setIsLoading(false);

    // [NONAKTIF SEMENTARA] Sistem Idle Timeout
    // let idleTimer;
    // const handleIdleTimeout = () => {
    //   idleTimer = setTimeout(() => {
    //     handleLogoutAPI();  
    //   }, 600000); // 10 menit
    // };


    const handleLogoutAPI = () => {
      PostByAgg({
        url: 'user/um/v1/logout', // Ganti URL sesuai dengan API logout Anda
        body: { email: email },  // Mengirim email ke server
        onResponse: (response) => {
          console.log("Logout API Response:", response);
          if (response.data.code === "2002000") {
            // Menghapus cookies jika logout sukses
            Cookies.remove("email", { path: '/' });
            Cookies.remove("roleCode", { path: '/' });
            Cookies.remove("musicLabelCode", { path: '/' });
            Cookies.remove("musicLabelName", { path: '/' });
            Cookies.remove("roleName", { path: '/' });
            Cookies.remove("isLoggedIn", { path: '/' });

            setIsLoggedIn(false);
            setEmail('');
            setRoleCode('');
            setRoleName('');
            setMusicLabelCode('');
            setMusicLabelName('');

            // Arahkan pengguna ke halaman login setelah logout
            // window.location.href = "/login";
          } else {
            console.log("Error on Logout API:", response.data.message);
          }
        },
        onError: (error) => {
          console.error("Error during API logout:", error);
          // Jika API gagal, logout secara manual
          Cookies.remove("email", { path: '/' });
          Cookies.remove("roleCode", { path: '/' });
          Cookies.remove("musicLabelCode", { path: '/' });
          Cookies.remove("musicLabelName", { path: '/' });
          Cookies.remove("roleName", { path: '/' });
          Cookies.remove("isLoggedIn", { path: '/' });

          setIsLoggedIn(false);
          window.location.href = "/login"; // Arahkan ke login jika API gagal
        }
      });
    };

    // [NONAKTIF SEMENTARA] Event listener untuk memantau aktivitas pengguna
    // const resetIdleTimer = () => {
    //   clearTimeout(idleTimer);
    //   handleIdleTimeout();
    // };

    // window.addEventListener('mousemove', resetIdleTimer);
    // window.addEventListener('keydown', resetIdleTimer);
    // window.addEventListener('click', resetIdleTimer);

    // handleIdleTimeout();

    return () => {
      // [NONAKTIF SEMENTARA]
      // window.removeEventListener('mousemove', resetIdleTimer);
      // window.removeEventListener('keydown', resetIdleTimer);
      // window.removeEventListener('click', resetIdleTimer);
      // clearTimeout(idleTimer);
    };

  }, [email]);


  return (
    <AuthContext.Provider value={{ email, setEmail,setRoleCode,setMusicLabelCode,musicLabelCode,musicLabelName,setMusicLabelName, roleCode,roleName,setRoleName, isLoggedIn, setIsLoggedIn, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
